import * as AUTH from "./auth";
const axios = require("axios");

export async function getVideoList(page, params) {
    let accessToken = await AUTH.getAccessToken();
    let url =
      process.env.REACT_APP_API_URL +
      "/" +
      process.env.REACT_APP_API_PREFIX +
      "/ml-educational-video?" +
      "page=" +
      page +
      "&per_page=10"
    if (params) {
      if (params.search) url += "&search=" + params.search;

      if (params.category) {
        if (params.category == "-- Select --") {
          params.category = ""
        }
        url += "&categories=" + params.category;
      }

      if (params.sortType) url += "&sort_type=" + params.sortType ;
      if (params.sortby) url += "&sort_by=" + params.sortby ;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          timeout: 60000,
          headers: {
            Authorization: "Bearer " + accessToken
          }
        })
        .then(response => {
          const { data } = response;
          resolve(data);
        })
        .catch((error) => {
          reject(error.message);
        })
        .finally();
    });
  }

export async function addVideo(createData) {
  let accessToken = await AUTH.getAccessToken();
  let data = new FormData();

  data.append("name", createData.name);
  data.append("desc", createData.desc);
  data.append("status", createData.status);
  // data.append("is_feature",createData.is_feature);
  data.append("category[0][id]",createData.category); 

  if (createData.image) {
    data.append("image", createData.image);
  }

  createData.videos.forEach((video,index)=>{
    data.append("videos[" + index + "][video_name]",video.name);
    data.append("videos[" + index + "][video_url]",video.url);
    data.append("videos[" + index + "][order]",video.order); 
  });

  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_API_URL + "/" 
        + process.env.REACT_APP_API_PREFIX + 
        "/ml-educational-video",data,
        {
        timeout: 60000,
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + accessToken
        }
      }
      )
      .then(response => {
        const { data } = response;
        resolve(data);
      })
      .catch(error => {
        if (!accessToken) {
          reject("token");
        } else {
          reject(error.message)
        }
      })
      .finally();
  });

}

export async function getVideoDetail(id) {
  let accessToken = await AUTH.getAccessToken();
  return new Promise((resolve, reject) => {
    axios
      .get(process.env.REACT_APP_API_URL + "/" + 
        process.env.REACT_APP_API_PREFIX + 
        "/ml-educational-video/" + id, {
        timeout: 60000,
        headers: {
          Authorization: "Bearer " + accessToken
        }
      })
      .then(response => {
        const { data } = response;
        resolve(data);
      })
      .catch(error => {
        if (!accessToken) {
          reject("token");
        } else {
          reject(error.message)
        }
      })
      .finally();
  });

}

export async function updateVideo(updateData) {
  let accessToken = await AUTH.getAccessToken();
  let data = new FormData();

  data.append("name", updateData.name);
  data.append("desc", updateData.desc);
  data.append("status", updateData.status);
  // data.append("is_feature",updateData.is_feature);
  data.append("category[0][id]",updateData.category); 

  if(updateData.image_filename) {
    data.append("image_filename",updateData.image_filename);
  } 
  else {
    if (updateData.image) {
      data.append("image", updateData.image);
    }
  }

  updateData.videos.forEach((video,index)=>{
    data.append("videos[" + index + "][video_name]",video.name);
    data.append("videos[" + index + "][video_url]",video.url);
    data.append("videos[" + index + "][order]",video.order); 
    if (video.edu_id) {
      data.append("videos[" + index + "][id]",video.id);
    }
  });

  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_API_URL +
          "/" +
          process.env.REACT_APP_API_PREFIX +
          "/ml-educational-video/" +
          updateData.id +
          "?_method=PUT",
        data,
        {
        timeout: 60000,
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + accessToken
        }
      }
      )
      .then(response => {
        const { data } = response;
        resolve(data);
      })
      .catch(error => {
        if (!accessToken) {
          reject("token");
        } else {
          reject(error.message)
        }
      })
      .finally();
  });
}

export async function deleteVideo(id) {
  let accessToken = await AUTH.getAccessToken();
  return new Promise((resolve, reject) => {
    axios
      .delete(process.env.REACT_APP_API_URL + "/"
        + process.env.REACT_APP_API_PREFIX
        + "/ml-educational-video/" + id, {
        timeout: 60000,
        headers: {
          Authorization: "Bearer " + accessToken
        }
      })
      .then(response => {
        const { data } = response;
        resolve(data);
      })
      .catch(error => {
        if (!accessToken) {
          reject("token");
        } else {
          reject(error.message)
        }
      })
      .finally();
  });
}